<div class="wrapper">
    <owl-carousel-o [options]="customOptions">
        <!-- slide 1 -->
        <ng-template class="slide" carouselSlide id="2">
            <div class="slide-item" style="background-image: url(../../../assets/images/b3.jpg);">


                <div class="ms-anim-layers" style=""><img class="ms-layer ms-hover-active"
                        src="../../../assets/images/Untitled-12.png" alt="" style="height: 100%; width: 100%; 
                        position: absolute;">

                    <div class="btn-container">

                        <div class="ms-btn-container" style="">
                            <a target="_blank" routerLink="/services/aban-yekom-fund"
                                class="ms-layer  msp-cn-7-142 ms-btn ms-btn-round ms-btn-n msp-preset-btn-200 ms-hover-active"
                                style="position: relative; margin: 0px; padding: 10px 36px; font-size: 18px; transform-origin: 50% 50%;">
                                اطلاعات بیشتر</a>
                        </div>

                        <div class="ms-btn-container">
                            <a target="_blank" href="http://aban.aban.net"
                                class="ms-layer  msp-cn-7-141 ms-btn ms-btn-round ms-btn-n msp-preset-btn-197 ms-hover-active"
                                style="position: relative; padding: 10px 36px; font-size: 18px; transform-origin: 50% 50%;">
                                ورود به سایت</a>
                        </div>

                    </div>
                    <h4 class="ms-layer-3 ms-hover-active"
                        style="color: white; position:absolute; bottom:140px; right: 8%; margin: 0px; padding: 0px; transform-origin: 50% 50%;">
                        صندوق سرمایه‌گذاری یکم آبان
                    </h4>
                    <!-- <img class="ms-layer-3 d-sm-none ms-hover-active" src="../../../assets/images/d3.png" alt=""
                        style="width: 630px; bottom:-60px; right: 0; height: 450px; margin: 0px; padding: 0px; transform-origin: 50% 50%;"> -->


                    <h2 class="ms-layer-4 ms-hover-active" style="color: white;font-weight: bold;">
                        ۶۰.۵ ٪ بازدهی سال ۱۴۰۱
                    </h2>
                    <!-- <img  src="../../../assets/images/u3.png" alt="" style=""> -->

                    <img class="line ms-hover-active" src="../../../assets/images/sl-line.png" alt=""
                        style="width: 90%;">
                </div>
            </div>



        </ng-template>
        <!-- slide 2 -->
        <ng-template class="slide" carouselSlide id="1">
            <div class="slide-item"
                style="background-image: url(../../../assets/images/dedicated_fund_management.jpg);">


                <div class="ms-anim-layers" style=""><img class="ms-layer ms-hover-active"
                        src="../../../assets/images/Untitled-12.png" alt="" style="height: 100%; width: 100%; 
                        position: absolute;">
                    <div class="btn-container">

                        <div class="ms-btn-container" style="">
                            <a target="_blank" routerLink="/services/dedicated-investment-management"
                                class="ms-layer  msp-cn-7-142 ms-btn ms-btn-round ms-btn-n msp-preset-btn-200 ms-hover-active"
                                style="position: relative; margin: 0px; padding: 10px 36px; font-size: 18px; transform-origin: 50% 50%;">
                                اطلاعات بیشتر</a>
                        </div>
                        <div class="ms-btn-container">
                            <a target="_blank" href="https://portfolio.aban.net/auth/login"
                                class="ms-layer  msp-cn-7-141 ms-btn ms-btn-round ms-btn-n msp-preset-btn-197 ms-hover-active"
                                style="position: relative; padding: 10px 36px; font-size: 18px; transform-origin: 50% 50%;">
                                ورود به سایت</a>
                        </div>

                    </div>

                    <h4 class="ms-layer-3 ms-hover-active"
                        style="color: white; position:absolute; bottom:140px; right: 8%; margin: 0px; padding: 0px; transform-origin: 50% 50%;">
                        سبدهای سرمایه‌گذاری اختصاصی
                    </h4>


                    <h2 class="ms-layer-4 ms-hover-active" style="color: white;font-weight: bold;">
                        ۵۸ ٪ بازدهی سال ۱۴۰۱
                    </h2>


                    <!-- <img class="ms-layer-1 ms-hover-active d-sm-none" src="../../../assets/images/samane.png" alt=""
                        style="width: 100%; max-width: 630px; bottom:-50px; right: 0; height: 450px; margin: 0px; padding: 0px; transform-origin: 50% 50%;">

                    <img class="ms-layer-2 ms-hover-active" src="../../../assets/images/didgh.png" alt="" style="">
 -->
                    <img class="line ms-hover-active" src="../../../assets/images/sl-line.png" alt=""
                        style="width: 90%;">
                </div>
            </div>



        </ng-template>


        <!-- slide 3 -->
        <ng-template class="slide" carouselSlide id="2">
            <div class="slide-item" style="background-image: url(../../../assets/images/b1.jpg);  ">


                <div class="ms-anim-layers" style=""><img class="ms-layer ms-hover-active"
                        src="../../../assets/images/Untitled-12.png" alt="" style="height: 100%; width: 100%; 
                        position: absolute;">
                    <div class="btn-container">


                        <div class="ms-btn-container" style=" ">
                            <a target="_blank" routerLink="/services/pars-fund"
                                class="ms-layer  msp-cn-7-142 ms-btn ms-btn-round ms-btn-n msp-preset-btn-200 ms-hover-active"
                                style="position: relative; margin: 0px; padding: 10px 36px; font-size: 18px; transform-origin: 50% 50%;">
                                اطلاعات بیشتر</a>
                        </div>

                        <div class="ms-btn-container">
                            <a target="_blank" href="http://pars.aban.net"
                                class="ms-layer  msp-cn-7-141 ms-btn ms-btn-round ms-btn-n msp-preset-btn-197 ms-hover-active"
                                style="position: relative; padding: 10px 36px; font-size: 18px; transform-origin: 50% 50%;">
                                ورود به سایت</a>
                        </div>
                    </div>

                    <h4 class="ms-layer-3 ms-hover-active"
                        style="color: white; position:absolute; bottom:140px; right: 5%; margin: 0px; padding: 0px; transform-origin: 50% 50%; width: 100%;">
                        مدیریت دارایی برای دوران بازنشستگی شما
                    </h4>


                    <h2 class="ms-layer-4 ms-hover-active" style="color: white;font-weight: bold; width: 100%;right: 5%;">
                        صندوق سرمایه‌گذاری پارس
                    </h2>
                    <!-- <img class="ms-layer-5 d-sm-none ms-hover-active" src="../../../assets/images/samane2-.png" alt=""
                        style="width:630px;  bottom:-60px; right: 70px; height: 450px; margin: 0px; padding: 0px; transform-origin: 50% 50%;">

                    <img class="ms-layer-6  ms-hover-active" src="../../../assets/images/pars.png" alt="" style=""> -->

                    <img class="line ms-hover-active" src="../../../assets/images/sl-line.png" alt=""
                        style="width: 90%;">
                </div>
            </div>
        </ng-template>

    </owl-carousel-o>
</div>